import React, { useState } from "react";
import { makeStyles, InputLabel, Box, FormHelperText } from "@material-ui/core";
import clsx from "clsx";
import ReactPhoneInput from "../../customizedLibs/phoneInput";

const useStyles = makeStyles(theme => ({
  telInputWrapper: {
    paddingTop: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    position: "relative"
  },
  telLabel: {
    fontSize: "0.6875rem",
    color: "#808080",
    position: "absolute",
    top: 5,
    left: 12,
    backgroundColor: "#FFF",
    zIndex: 1
  },
  telInput: {
    marginTop: "1px !important",

    "& input": {
      width: "100% !important",
      border: "1px solid #E0E2E5 !important",
      height: "53.63px !important",
      padding: "18.5px 14px 18.5px 48px!important",
      backgroundColor: "transparent !important",
      fontSize: "0.9375rem !important",
      borderRadius: "4px !important",
      boxSizing: "border-box"
    },

    "& .flag-dropdown": {
      backgroundColor: "transparent !important"
    },
    "& .selected-flag": {
      backgroundColor: "transparent !important",
      padding: "0 12px"
    },

    "&.Mui-error": {
      "& input": {
        border: "1px solid #D93024 !important"
      }
    }
  },
  telHelperText: {
    fontSize: "0.6875rem",
    lineHeight: "0.8125rem",
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5)
  },
  borderStyle: {
    "& .MuiInput-underline.Mui-disabled:before": {
      borderBottomStyle: "solid"
    }
  }
}));

function PhoneInput({
  editStop,
  label,
  dataCy,
  countryCode,
  published,
  phoneError,
  phoneNumber,
  handlePhoneChange,
  disabled
}) {
  const classes = useStyles();
  const [telFocused, setTelFocused] = useState(false);

  return (
    <Box
      className={clsx(classes.telInputWrapper, {
        [classes.borderStyle]: editStop && published
      })}
    >
      <InputLabel
        className={clsx(classes.telLabel, "MuiFormLabel-root", {
          "Mui-focused": telFocused,
          "Mui-error": phoneError,
          "Mui-disabled": published
        })}
        htmlFor="tel-input"
      >
        {label}
      </InputLabel>

      <ReactPhoneInput
        country={(countryCode && countryCode.toLowerCase()) || "us"}
        value={phoneNumber || ""}
        onChange={handlePhoneChange}
        onFocus={() => setTelFocused(true)}
        onBlur={() => setTelFocused(false)}
        containerClass={`${classes.telInput} ${telFocused && "Mui-focused"} ${
          phoneError && "Mui-error"
        } react-tel-input MuiInput-formControl MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInputBase-marginDense MuiInputBase-root ${
          (published || disabled) && "Mui-disabled"
        }`}
        inputClass={`form-control MuiInputBase-input MuiInput-input MuiInputBase-inputMarginDense MuiInput-inputMarginDense ${
          (published || disabled) && "Mui-disabled"
        }`}
        buttonStyle={{
          border: "none",
          backgroundColor: "transparent"
        }}
        defaultMask={".............."}
        alwaysDefaultMask={true}
        countryCodeEditable={false}
        inputExtraProps={{
          id: "tel-input",
          "data-cy": dataCy
        }}
        disabled={published || disabled}
      />
      <FormHelperText className={classes.telHelperText} error>
        {phoneError || " "}
      </FormHelperText>
    </Box>
  );
}

export default PhoneInput;
